import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function challenge() {
  return (
    <section className="problem_una p-100 text_una">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              <strong>The Problem</strong>
              <br /> The Problem Faced By Fresh Graduates With Finding Jobs
            </h2>
            <p>
              Finding the perfect job right after graduating is a long-running
              dilemma. Fresh graduates experience difficulty in getting hired
              for a job without experience. Therefore, it becomes difficult to
              survive in the growing economy to lead a stable life. People with
              job experience have famous platforms like LinkedIn to connect with
              hiring professionals and find jobs. Still, it's seldom for a fresh
              graduate to start their career quickly after completing their
              degree.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/una/problem_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={759}
                height={824}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default challenge;
